import Api from "../../../config/api";
import {
  CREATE_INVOICE,
  DELETE_INVOICE_SOFT,
  SEARCH_INVOICE,
  SEARCH_INVOICE_BY_ID,
  UPDATE_INVOICE,
} from "../../../utils/constants";
import { showToast } from "../../toast/ShowToast";

export const getInvoice = async (params?: any) => {
  try {
    const res = await Api(false).get(SEARCH_INVOICE, { params });
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const getInvoiceById = async (id?: string) => {
  try {
    const res = await Api(false).get(`${SEARCH_INVOICE_BY_ID}/${id}`);
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const createInvoice = async (body: any, hideLoader: () => void) => {
  try {
    const res = await Api(false).post(CREATE_INVOICE, body);
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      let msg = error?.response?.data?.message.split(":");
      if (msg[2] === " invoiceNumber_1_company_1 dup key") {
        showToast(`Invoice number already taken`, "error");
        hideLoader();
        return error;
      } else {
        showToast(`${error?.response?.data?.message}`, "error");
        hideLoader();
      }
    }
  }
};

export const updateInvoice = async (
  body: any,
  id: string,
  hideLoader: () => void
) => {
  try {
    const res = await Api(false).put(`${UPDATE_INVOICE}/${id}`, body);
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};

export const restoreInvoice = async (body: any, hideLoader: () => void) => {
  try {
    const res = await Api(false).delete(`${DELETE_INVOICE_SOFT}`, {
      data: body,
    });
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};
